import { InlineResponse20065Result } from "../../bookmydesk-api-sdk-typescript-axios";

export const kReservationsStatisticsToday: InlineResponse20065Result = {
  homeReservationCount: 40,
  officeReservationCount: 158,
  parkingSpotReservationCount: 0,
  parkingSpotTotalCount: 0,
  seatTypeReservationCount: {
    desk: 0,
    meeting: 0,
    lunch: 0,
  },
  seatTypeTotalCount: {
    desk: 0,
    meeting: 0,
    lunch: 0,
  },
};
